import { Flex, Input, Select } from "@chakra-ui/react";
import React from "react";
import { useEffect } from "react";
import * as S from "../styles";

const FiltroContabilidade = ({
  ListarFiltroInfoTelaIcms,
  noteView,
  setform_data_saida,
  setform_data_entrada,
  labelSaida,
  labelPronto,
  setform_numero_pedido,
  form_data_entrada,
  form_data_saida,
  form_numero_pedido,
  pendencia,
  setpendencia,
  dataDeUp,
  dataAteUp,
  setFilter,
  filter,
  handleFilterValues,
}) => {
  return (
    <>
      <S.ContabilidadeFiltroContainer>
        <S.ContabilidadeBoxInputContainer className="form__group field">
          <Input
            autoFocus
            type="number"
            onChange={(e) => setFilter({ ...filter, numero_pedido: e.target.value })}
            className="form__field"
            placeholder="Número Pedido"
            name="numero_pedido"
            id="numero_pedido"
            required
          />
          <label htmlFor="numero_pedido" className="form__label">
            Número Pedido
          </label>
        </S.ContabilidadeBoxInputContainer>

        <S.ContabilidadeFlexInput>
          <label style={{ top: dataDeUp ? "20px" : "40px" }} id="label_data_pronto">
            De:
          </label>
          <Input
            onKeyPress={(e) => (e.key == "Enter" ? null : null)}
            onClick={(e) => {
              labelPronto();
            }}
            id="data_pronto"
            focusBorderColor="#3a7993"
            onChange={(e) => setFilter({ ...filter, data_entrada: e.target.value })}
            className="form__field"
            placeholder="Data Pronto"
            name="data_pronto"
            required
            type="date"
          />

          <label style={{ top: dataAteUp ? "20px" : "40px" }} id="label_data_saida">
            Até:
          </label>
          <Input
            onClick={(e) => {
              labelSaida();
            }}
            id="data_saida"
            focusBorderColor="#3a7993"
            type="date"
            onChange={(e) => setFilter({ ...filter, data_saida: e.target.value })}
            className="form__field"
            placeholder="Data Saida"
            name="data_saida"
            required
          />
        </S.ContabilidadeFlexInput>

        <Flex w="100px" h="60px" position="relative" top="9px" flexDir="column">
          <label
            style={{
              textAlign: "center",
              color: "#9b9b9b",
              position: "relative",
              right: noteView ? "0px" : "100px",
              top: noteView ? "0px" : "35px",
            }}
          >
            Pendência
          </label>
          <Select
            borderBottom="1px solid #3a7993"
            onKeyPress={(e) => (e.key == "Enter" ? null : null)}
            name="pendencia"
            onChange={(e) => setFilter({ ...filter, pendencia: e.target.value })}
            focusBorderColor="#3a7993"
            h="40px"
            w="100px"
            defaultValue={"3"}
          >
            <option value="0">Selecione</option>
            <option value="3">Sim</option>
            <option value="4">Não</option>
          </Select>
        </Flex>
      </S.ContabilidadeFiltroContainer>
      <S.ContabilidadeFlexButtonContainer>
        <S.ContabilidadeButtonFiltrar
          onKeyPress={(e) => (e.key == "Enter" ? null : null)}
          onClick={() => handleFilterValues()}
          id="enviar"
        >
          Filtrar
        </S.ContabilidadeButtonFiltrar>
      </S.ContabilidadeFlexButtonContainer>
    </>
  );
};

export default FiltroContabilidade;
